export default __webpack_public_path__ + "media/Night.2deab10e.svg";